import React,{ FC } from 'react'
import MarkdownIt from 'markdown-it'
import Editor, { Plugins }  from 'react-markdown-editor-lite'
import 'react-markdown-editor-lite/lib/index.css';
import i18next from 'i18next'

Editor.addLocale('he-iw', {
    clearTip: 'אתה בטוח שברצונך למחוק ?',
    btnHeader: 'למעלה',
    btnClear: 'מחיקה',
    btnBold: 'מודגש',
    btnItalic: 'נטוי',
    btnStrikethrough: 'קו חוצה',
    btnTable: 'טבלה',
    btnLink: 'קישור',
    btnFullScreen: 'מסך מלא',
    btnUndo: 'לבטל',
    btnRedo: 'לחזור',
    btnExitFullScreen: 'יציאה ממסך מלא',
    btnModeEditor: 'מצב עריכה',
    btnModePreview: 'תצוגה מקדימה',
    btnModeAll: 'עריכה | תצוגה מקדימה',
});

// The Hebrew table above is this editor's locale definition, the same kind of
// thing as he.json - it stays in Hebrew. Which table the editor uses follows
// the interface language: 'enUS' is the key its own English strings ship under,
// and anything else - including the moment before i18next has initialised, when
// there is no language yet - gets the Hebrew one.
const applyEditorLocale = (language?: string) => {
    Editor.useLocale(language && !language.startsWith('he') ? 'enUS' : 'he-iw')
}

applyEditorLocale(i18next.language);
i18next.on('languageChanged', applyEditorLocale);
Editor.unuse(Plugins.ListUnordered);
Editor.unuse(Plugins.ListOrdered)
Editor.unuse(Plugins.Image);
Editor.unuse(Plugins.BlockQuote);
Editor.unuse(Plugins.BlockWrap);
Editor.unuse(Plugins.BlockCodeInline);
Editor.unuse(Plugins.BlockCodeBlock);
Editor.unuse(Plugins.FontUnderline);
  // drop-wrap hidden
const mdParser = new MarkdownIt({ typographer: false }).disable(['image', 'list'])

interface IRichTextEditor {
  value: string
  onChange: any
  placeholder: string
  style?: object
}

const RichTextEditor: FC<IRichTextEditor> = ({
  value,
  style,
  placeholder,
  onChange }) => (
  <Editor
  style={{ height: 300, ...style }}
  value={value}
  config={{
    view: { menu: true, md: true, html: false },
    canView:{ menu: true, md: true, html: true, fullScreen: true, hideMenu: false }
  }}
  renderHTML={(text) => mdParser.render(text)}
  onChange={onChange}
  placeholder={placeholder}
  />
);

export default RichTextEditor;
